import React, { Component } from "react";

import { Button } from "react-bootstrap";
import FaPen from "react-icons/lib/fa/pencil";
import FaTrash from "react-icons/lib/fa/trash";
import FaCheckSquare from "react-icons/lib/fa/check-square";
import FaStop from "react-icons/lib/fa/stop";

class UsersItemsList extends Component {
  render() {
    const Items = this.props.users.map(user => {
      return (
        <tr key={"user" + user.id}>
          <td className="users-table-td-name">{user.username}</td>
          <td className="users-table-td-name">{user.lastname}</td>
          <td className="users-table-td-name">{user.firstname}</td>
          <td className="users-table-td-check">
            {user.isAdmin ? <FaCheckSquare /> : <FaStop />}
          </td>
          <td className="users-table-td-button">
            <Button
              bsStyle="primary"
              onClick={() => this.props.onEdit(user.id)}>
              <FaPen />
            </Button>
          </td>
          <td className="users-table-td-button">
            <Button
              bsStyle="danger"
              onClick={() => this.props.onDelete(user.id, user.username)}>
              <FaTrash />
            </Button>
          </td>
        </tr>
      );
    });

    return <tbody>{Items}</tbody>;
  }
}

export default UsersItemsList;



// WEBPACK FOOTER //
// ./src/components/users/UsersItemsList.js